import React, { Component } from 'react';
import Config from '../../Config';

class Tips extends Component {
    render() {
        return (
            <div className="tips">
                <h3 style={{color: Config.colors.theme}}>더 나은 생성</h3>
                <p>
                    모델의 입력은 랜덤 노이즈 부분과 조건 부분의 두 부분으로 구성됩니다.
                    좋은 이미지를 생성했다면 <strong>노이즈 부분을 수정</strong>하고 임의의 조건을 사용하여 더 좋은 이미지를 얻을 수 있습니다.
                    우리는 더 나은 생성을 위해 좋은 랜덤 노이즈가 중요하다는 것을 관찰했습니다.
                </p>
                <h3 style={{color: Config.colors.theme}}>더 빠른 생성</h3>
                <p>
                    현재 모든 계산은 <a href="https://mil-tokyo.github.io/webdnn/" target="_blank" rel="noopener noreferrer">WebDNN</a>을 통해 웹 브라우저에서 수행됩니다. 기본적으로 WebAssembly를 백엔드로 사용합니다.
                    그러나 Mac 사용자인 경우 <a href="https://developer.apple.com/safari/technology-preview/" target="_blank" rel="noopener noreferrer">Safari Technology Preview를 설치해 볼 수 있습니다. </a> 및
                    개발 -> 실험적 기능 -> WebGPU에서 WebGPU를 켭니다.
                    이렇게 하면 WebAssembly보다 <strong>100배 더 빠른</strong> WebGPU 백엔드가 활성화됩니다! WebGPU는 현재 <a href="https://github.com/mil-tokyo/webdnn/issues/286" target="_blank" rel="noopener noreferrer">여기</a>에 보고된 대로 AMD GPU에서 작동하지 않을 수 있습니다.

                </p>

                {/*<h3 style={{color: Config.colors.theme}}>Model detail</h3>*/}
                {/*<p> The current model is based on <a href="https://arxiv.org/abs/1406.2661" target="_blank"> Generative Adversarial Networks</a>. Technically, it uses <a href="https://arxiv.org/abs/1610.09585" target="_blank">AC-GAN</a> to do conditional*/}
                    {/*generation, along with a <a href="https://arxiv.org/abs/1705.07215" target="_blank"> DRAGAN</a>-style gradient penalty term in training. The generator is based on a <a href="https://arxiv.org/abs/1609.04802" target="_blank">SRResNet</a>-like structure.</p>*/}

            </div>
        );
    }
}

export default Tips;
/**
 * Created by aixile on 2017/07/20.
 */



// WEBPACK FOOTER //
// ./src/components/pages/Tips.js